module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer",
      "data-turbolinks-permanent": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('img', {
    staticClass: "media-object",
    staticStyle: {
      "width": "64px"
    },
    attrs: {
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/c309db0b49cab85a32f756541ea0e2b0.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "links"
  }, [_c('a', {
    attrs: {
      "href": "/wiki/about"
    }
  }, [_vm._v("关于")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "http://rubyconfchina.org",
      "target": "_blank",
      "title": "RubyConf China 大会"
    }
  }, [_vm._v("RubyConf")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/wiki/ruby-mirror",
      "title": "Ruby 镜像"
    }
  }, [_vm._v("Ruby 镜像")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "https://&#10;gems.ruby-china.org",
      "target": "_blank",
      "title": "RubyGems 镜像"
    }
  }, [_vm._v("RubyGems 镜像")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/status",
      "target": "_blank"
    }
  }, [_vm._v("Status")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/users"
    }
  }, [_vm._v("活跃会员")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/teams"
    }
  }, [_vm._v("组织")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/api"
    }
  }, [_vm._v("API")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "/wiki/contributors"
    }
  }, [_vm._v("贡献者")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n        中国 Ruby 社区，由众多爱好者共同维护，致力于构建完善的 Ruby 中文社区。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "supports",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("服务器由 "), _c('a', {
    attrs: {
      "href": "http://www.ucloud.cn/?utm_source=zanzhu&utm_campaign=rubychina&utm_medium=display&utm_content=yejiao&ytag=rubychina_logo",
      "target": "_blank",
      "rel": "twipsy",
      "title": "",
      "data-original-title": "本站服务器由 UCloud 赞助"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "margin-top": "-2px"
    },
    attrs: {
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/e1eb47a05578576bf134da65736cc5b4.png"
    }
  })]), _vm._v(" 赞助")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("CDN 由 "), _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "https://www.upyun.com/?utm_source=ruby-china&utm_medium=ad&utm_campaign=upyun&md=ruby-china",
      "target": "_blank",
      "rel": "twipsy",
      "title": "",
      "data-original-title": "CDN, Ruby Mirror, RubyGems CDN 由又拍云赞助"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "margin-top": "-2px"
    },
    attrs: {
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/3ad734d65891632fb049ba97044ba5a4.png"
    }
  })]), _vm._v(" 赞助")]), _vm._v(" "), _c('span', [_vm._v("Gem 服务器由\n        "), _c('a', {
    attrs: {
      "href": "http://www.qcloud.com?ref=ruby-china",
      "target": "_blank",
      "rel": "twipsy",
      "title": "",
      "data-original-title": "腾讯云为 RubyGems 镜像提供国外服务器支持"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "margin-top": "-3px"
    },
    attrs: {
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/1977b4bcf6589a03fb4d21139955aa6a.png"
    }
  })]), _vm._v(" 赞助")])]), _vm._v(" "), _c('div', {
    staticClass: "links",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('span', {
    staticClass: "socials"
  }, [_c('a', {
    attrs: {
      "href": "http://github.com/ruby-china",
      "target": "_blank",
      "rel": "nofollow",
      "title": "本站在 GitHub 上面的开源内容"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://twitter.com/ruby_china",
      "target": "_blank",
      "rel": "nofollow",
      "title": "本站的 Twitter 账号"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://weibo.com/u/3168836987",
      "target": "_blank",
      "rel": "nofollow",
      "title": "本站的 Weibo 账号"
    }
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCOLKFS_uA7nX26_u8z9V9og/feed",
      "target": "_blank",
      "rel": "nofollow",
      "title": "本站在 YouTube 上面的视频内容"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/topics/feed",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/ruby-china/id1072028763"
    }
  }, [_vm._v("iOS 客户端")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=org.ruby_china.android"
    }
  }, [_vm._v("Android 客户端")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "href": "?locale=zh-CN",
      "rel": "nofollow"
    }
  }, [_vm._v("简体中文")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "?locale=zh-TW",
      "rel": "nofollow"
    }
  }, [_vm._v("正體中文")]), _vm._v(" / "), _c('a', {
    attrs: {
      "href": "?locale=en",
      "rel": "nofollow"
    }
  }, [_vm._v("English")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e4dc040!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Footer.vue
// module id = 284
// module chunks = 6